import React from "react";
import { useTranslation } from "react-i18next";
import { ReadingTile } from "@ui/components/temperature";
import { NO_READING } from "@ui/utils/environment-readings";
import { limitReason, limitStatusOf } from "@ui/utils/sensor-limit-status";
/**
 * A reading of a new-hardware sensor in a table row, as a tile. Within its limits (or without any) it has the sensor's own
 * colour; outside them it is red and the info tooltip says why (e.g. "Humidity too high (60%)"); without a value it is grey.
 */
export const SensorReading = ({ value, unit, decimals = 0, tone, inactive = false, sensorType, sensorLabel, statuses, }) => {
    const { t } = useTranslation("common");
    const outOfRange = limitStatusOf(statuses, sensorType);
    const status = outOfRange ? statuses === null || statuses === void 0 ? void 0 : statuses.find((s) => s.sensorType === sensorType) : undefined;
    const tileTone = inactive || value == null ? "inactive" : outOfRange ? "error" : tone;
    return (React.createElement(ReadingTile
    // "--.-" for a temperature, like its main tile.
    , { 
        // "--.-" for a temperature, like its main tile.
        value: value == null ? (decimals ? `${NO_READING}.-` : NO_READING) : Number(value).toFixed(decimals), unit: unit, tone: tileTone, infoTooltip: React.createElement("span", { style: { whiteSpace: "pre-line" } }, status ? limitReason(status, t) : sensorLabel) }));
};
